// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Rect$SmartcutsMacros = require("./Rect.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Image$SmartcutsMacros = require("./Image.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var Browser__Tabs$SmartcutsMacros = require("./browser/Browser__Tabs.bs.js");
var Browser__Helpers$SmartcutsMacros = require("./browser/Browser__Helpers.bs.js");
var Browser__Helpers2$SmartcutsMacros = require("./browser/Browser__Helpers2.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../bs-utils/src/JsPromiseErrorUtils.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    return ["NoImage"];
  }
  switch (v.TAG | 0) {
    case /* Image */0 :
        return [
                "Image",
                Image$SmartcutsMacros.id_encode(v._0),
                Image$SmartcutsMacros.t_encode(v._1)
              ];
    case /* SavingToCloud */1 :
        return [
                "SavingToCloud",
                Image$SmartcutsMacros.id_encode(v._0),
                Image$SmartcutsMacros.t_encode(v._1)
              ];
    case /* Cloud */2 :
        return [
                "Cloud",
                Image$SmartcutsMacros.id_encode(v._0),
                Decco.stringToJson(v._1)
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Cloud" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Image$SmartcutsMacros.id_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Cloud */2,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Image" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Image$SmartcutsMacros.id_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Image$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Image */0,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "NoImage" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoImage */0
                  };
          }
      case "SavingToCloud" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Image$SmartcutsMacros.id_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = Image$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SavingToCloud */1,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$4 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function minify(v) {
  if (typeof v === "number") {
    return /* NoImage */0;
  }
  switch (v.TAG | 0) {
    case /* Image */0 :
        return {
                TAG: /* Image */0,
                _0: v._0,
                _1: Image$SmartcutsMacros.minify(v._1)
              };
    case /* SavingToCloud */1 :
        return {
                TAG: /* SavingToCloud */1,
                _0: v._0,
                _1: Image$SmartcutsMacros.minify(v._1)
              };
    case /* Cloud */2 :
        return {
                TAG: /* Cloud */2,
                _0: v._0,
                _1: v._1
              };
    
  }
}

function stringify(screenshot) {
  if (typeof screenshot === "number") {
    return "NoImage";
  }
  switch (screenshot.TAG | 0) {
    case /* Image */0 :
        return "Image(" + (Image$SmartcutsMacros.idAsString(screenshot._0) + ")");
    case /* SavingToCloud */1 :
        return "SavingToCloud(" + (Image$SmartcutsMacros.idAsString(screenshot._0) + ")");
    case /* Cloud */2 :
        return "Cloud(" + (Image$SmartcutsMacros.idAsString(screenshot._0) + (", " + (screenshot._1 + ")")));
    
  }
}

function deriveFolderName(recordedSmartcutId) {
  return "/" + (process.env.NEXT_PUBLIC_ENV + ("/" + recordedSmartcutId));
}

function deriveFileName(screenshotId, format) {
  return Image$SmartcutsMacros.idAsString(screenshotId) + ("." + Image$SmartcutsMacros.Format.extension(format));
}

function getSrcForImgTag(screenshot) {
  if (typeof screenshot === "number") {
    return "";
  }
  switch (screenshot.TAG | 0) {
    case /* Image */0 :
    case /* SavingToCloud */1 :
        return Image$SmartcutsMacros.Data.toImageSrc(screenshot._1.data);
    case /* Cloud */2 :
        return screenshot._1;
    
  }
}

function imageGet(screenshot) {
  if (typeof screenshot === "number") {
    return ;
  }
  switch (screenshot.TAG | 0) {
    case /* Image */0 :
    case /* SavingToCloud */1 :
        return screenshot._1;
    case /* Cloud */2 :
        return ;
    
  }
}

function idGet(screenshot) {
  if (typeof screenshot === "number") {
    return ;
  } else {
    return Caml_option.some(screenshot._0);
  }
}

function doesMatchId(id, screenshot) {
  if (typeof screenshot === "number") {
    return false;
  } else {
    return Caml_obj.caml_equal(screenshot._0, id);
  }
}

function tryToScreenshotTab(tabId, url, format, quality) {
  return Browser__Helpers2$SmartcutsMacros.runPromiseWhileAlsoHandlingTabDraggingError(function (param) {
                return Browser__Helpers$SmartcutsMacros.getActiveTabOfLastFocusedWindow(undefined);
              }).then(function (maybeFocusedTab_1) {
              var arg = OptionUtils$SmartcutsMacros.map(maybeFocusedTab_1, (function (tab) {
                      if (Caml_obj.caml_equal(tab.id, tabId)) {
                        return Caml_obj.caml_equal(tab.url, url);
                      } else {
                        return false;
                      }
                    }));
              var isTabWithUrlFocused_1 = (function (param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                  })(false);
              if (isTabWithUrlFocused_1) {
                return Browser__Tabs$SmartcutsMacros.captureVisibleTab(undefined, format, quality, undefined).then(function (image) {
                                return Promise.resolve(image);
                              }).catch(function (error) {
                              Curry._2(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.consoleError2, "error during screenshot", error);
                              var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, error);
                              if (typeof jsExn !== "number" && jsExn.TAG === /* MaxCaptureVisibleTabCallsPerSecondExceeded */1) {
                                console.warn("Delay strategy for MAX_CAPTURE_VISIBLE_TAB_CALLS_PER_SECOND not working");
                                console.error(jsExn._0);
                                return Promise.resolve(undefined);
                              }
                              return Util$SmartcutsMacros.waitForPromise(undefined, undefined, (function (param) {
                                                return Browser__Tabs$SmartcutsMacros.captureVisibleTab(undefined, format, quality, undefined).then(function (image) {
                                                              return Promise.resolve(image);
                                                            }).catch(function (error) {
                                                            Curry._2(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.consoleError2, "error during screenshot retry", error);
                                                            return Promise.resolve(undefined);
                                                          });
                                              }), undefined, undefined).then(function (image) {
                                            return Promise.resolve(image);
                                          }).catch(function (error) {
                                          Curry._2(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.consoleError2, "final screenshot error", error);
                                          return Promise.resolve(undefined);
                                        });
                            }).then(function (maybeImage) {
                            if (maybeImage !== undefined) {
                              return Browser__Helpers$SmartcutsMacros.getActiveTabOfLastFocusedWindow(undefined).then(function (maybeFocusedTab_2) {
                                          var arg = OptionUtils$SmartcutsMacros.map(maybeFocusedTab_2, (function (tab) {
                                                  if (Caml_obj.caml_equal(tab.id, tabId)) {
                                                    return Caml_obj.caml_equal(tab.url, url);
                                                  } else {
                                                    return false;
                                                  }
                                                }));
                                          var isTabWithUrlFocused_2 = (function (param) {
                                                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                              })(false);
                                          return Promise.resolve(isTabWithUrlFocused_2 ? maybeImage : undefined);
                                        });
                            } else {
                              return Promise.resolve(undefined);
                            }
                          });
              } else {
                return Promise.resolve(undefined);
              }
            });
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "rect",
                Rect$SmartcutsMacros.t_encode(v.rect)
              ],
              [
                "windowSize",
                Image$SmartcutsMacros.Size.t_encode(v.windowSize)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var rect = Rect$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rect"), null));
  if (rect.TAG === /* Ok */0) {
    var windowSize = Image$SmartcutsMacros.Size.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowSize"), null));
    if (windowSize.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                rect: rect._0,
                windowSize: windowSize._0
              }
            };
    }
    var e = windowSize._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".windowSize" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = rect._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".rect" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$1(param) {
  return "{rect: " + (Rect$SmartcutsMacros.stringify(param.rect) + (", windowSize: " + (Image$SmartcutsMacros.Size.stringify(param.windowSize) + "}")));
}

var TargetBoundingRectWithWindowSize = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "key",
                Image$SmartcutsMacros.id_encode(v.key)
              ],
              [
                "tabId",
                Decco.intToJson(v.tabId)
              ],
              [
                "url",
                Decco.optionToJson(Decco.stringToJson, v.url)
              ],
              [
                "targetBoundingRectWithWindowSize",
                Decco.optionToJson(t_encode$1, v.targetBoundingRectWithWindowSize)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var key = Image$SmartcutsMacros.id_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "key"), null));
  if (key.TAG === /* Ok */0) {
    var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
    if (tabId.TAG === /* Ok */0) {
      var url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
      if (url.TAG === /* Ok */0) {
        var targetBoundingRectWithWindowSize = Decco.optionFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetBoundingRectWithWindowSize"), null));
        if (targetBoundingRectWithWindowSize.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    key: key._0,
                    tabId: tabId._0,
                    url: url._0,
                    targetBoundingRectWithWindowSize: targetBoundingRectWithWindowSize._0
                  }
                };
        }
        var e = targetBoundingRectWithWindowSize._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".targetBoundingRectWithWindowSize" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = url._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".url" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = tabId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".tabId" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = key._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".key" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify$2(param) {
  var arg = OptionUtils$SmartcutsMacros.map(param.targetBoundingRectWithWindowSize, stringify$1);
  return "{key: " + (Image$SmartcutsMacros.idAsString(param.key) + (", tabId: " + (String(param.tabId) + (", url: " + (OptionUtils$SmartcutsMacros.withDefault("None", param.url) + (", targetBoundingRectWithWindowSize: " + ((function (param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                          })("None") + "}")))))));
}

function doesMatch(maybeKey, maybeTabId, param) {
  var arg = OptionUtils$SmartcutsMacros.map(maybeKey, (function (keyToMatch, key$p) {
          return Caml_obj.caml_equal(key$p, keyToMatch);
        }));
  var doesMatchKey = (function (param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
      })(function (param) {
        return true;
      });
  var arg$1 = OptionUtils$SmartcutsMacros.map(maybeTabId, (function (tabIdToMatch, tabId$p) {
          return tabId$p === tabIdToMatch;
        }));
  var doesMatchTabId = (function (param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
      })(function (param) {
        return true;
      });
  if (Curry._1(doesMatchKey, param.key)) {
    return Curry._1(doesMatchTabId, param.tabId);
  } else {
    return false;
  }
}

function cropImageToDesiredScreenshot(image, param) {
  var maybeTargetBoundingRectWithWindowSize = param.targetBoundingRectWithWindowSize;
  var currKey = param.key;
  if (maybeTargetBoundingRectWithWindowSize === undefined) {
    return Promise.resolve([
                currKey,
                undefined
              ]);
  }
  var windowSizeWhenBoundingRectTaken = maybeTargetBoundingRectWithWindowSize.windowSize;
  var boundingRect = maybeTargetBoundingRectWithWindowSize.rect;
  var arg = function (param, param$1) {
    return function (param$2) {
      return Image$SmartcutsMacros.cropToContainingCircle(param, param$1, boundingRect, windowSizeWhenBoundingRectTaken, param$2);
    };
  };
  return Curry._1(arg(undefined, undefined), image).then(function (maybeCroppedImage) {
              return Promise.resolve([
                          currKey,
                          maybeCroppedImage
                        ]);
            });
}

var DesiredTabScreenshot = {
  TargetBoundingRectWithWindowSize: TargetBoundingRectWithWindowSize,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2,
  doesMatch: doesMatch,
  cropImageToDesiredScreenshot: cropImageToDesiredScreenshot
};

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.minify = minify;
exports.stringify = stringify;
exports.deriveFolderName = deriveFolderName;
exports.deriveFileName = deriveFileName;
exports.getSrcForImgTag = getSrcForImgTag;
exports.imageGet = imageGet;
exports.idGet = idGet;
exports.doesMatchId = doesMatchId;
exports.tryToScreenshotTab = tryToScreenshotTab;
exports.DesiredTabScreenshot = DesiredTabScreenshot;
/* Rect-SmartcutsMacros Not a pure module */
